<!-- Gene Globes -->
<template>
	<div class="workflow-container-gg-cta">
		<banner
			:content="{
				title: 'Configure at GeneGlobe.',
				body:
					'This product has to be configured before purchase. Please configure and order this product directly on our GeneGlobe platform. ',
				version: 'warning',
			}"
			layout="small"
		>
			<template v-slot:buttons>
				<md-button
					class="md-primary md-border-primary gg-cta-button"
					@click="$emit('sendToGeneGlobeLink', articleNumber)"
				>
					<span class="caption-2">Open GeneGlobe</span>
					<base-icon icon-name="arrow-top-right" />
				</md-button>
			</template>
		</banner>
	</div>
</template>
<script>
export default {
	name: 'GeneGlobe',
	props: {
		articleNumber: {
			type: String,
		},
	},
};
</script>
<style lang="scss">
.workflow-container-gg-cta {
	padding: 0 16px 16px;
	.gg-cta-button {
		&.md-button {
			padding: 0px 4px;
			.caption-2 {
				letter-spacing: 0.4px;
				margin-right: 8px;
			}
		}
	}
	@media (max-width: $mobile) {
		padding: 16px;
	}
}
</style>
